const $ = window.jQuery;
const $window = window.$window || $(window);

const DocsNav = {

    init() {
        const $module = $('.DocsNav');
        if (!$module.length)
            return;

        $('#js-docs-nav-toggle').click((e) => {
            e.preventDefault();
            $module.toggleClass('hidden');
        });

        $module.find('.DocsNav__overlay').click((e) => {
            $module.addClass('hidden');
        });
    },

};

export default DocsNav;